'use client';

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import styles from '@/styles/Contact.module.css';
import ContactFormClientWrapper from '@/components/ContactForm/ContactFormClientWrapper';
import DonationButton from '@/components/common/DonationButton';

export default function ContactPageClient() {

  return (
    <>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1>Contact Us</h1>
          <p>Get in touch with TimeleeCares</p>
        </div>
      </section>

      {/* Contact Information */}
      <section className={styles.contactInfo}>
        <div className={styles.container}>
          <div className={styles.infoGrid}>
            <div className={styles.infoCard}>
              <div className={styles.infoIcon}>
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <h3>Phone</h3>
              <p>
                <a href="tel:+14707131902" className={styles.contactLink}>
                  (470) 713-1902
                </a>
              </p>
            </div>
            <div className={styles.infoCard}>
              <div className={styles.infoIcon}>
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <h3>Email</h3>
              <p>
                <a href="mailto:info@timeleecares.org" className={styles.contactLink}>
                  info@timeleecares.org
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form and Map Section */}
      <section className={styles.contactSection}>
        <div className={styles.sectionHeader}>
          <h2>Contact Us</h2>
          <p>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>
        <div className={styles.container}>
          <div className={styles.contactGrid}>
            <ContactFormClientWrapper className={styles.formWrapper} />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className={styles.faqSection}>
        <div className={styles.container}>
          <h2>Frequently Asked Questions</h2>
          <div className={styles.faqGrid}>
            <div className={styles.faqItem}>
              <h3>What are your office hours?</h3>
              <p>Our office is open Monday through Friday, 9:00 AM to 5:00 PM.</p>
            </div>
            <div className={styles.faqItem}>
              <h3>How can I volunteer?</h3>
              <p>Visit our <a href="/about" className={styles.faqLink}>about page</a> or contact us to learn about current opportunities.</p>
            </div>
            <div className={styles.faqItem}>
              <h3>Do you accept donations?</h3>
              <p>Yes, we accept both monetary and in-kind donations. Visit our <a href="/donate" className={styles.faqLink}>donate page</a> for more information.</p>
            </div>
          </div>
        </div>
      </section>

      <section className={`${styles.volunteer} ${styles.sectionSpacing}`}>
        <div className={styles.container}>
          <div className={styles.volunteerContent}>
            <div className={styles.volunteerTitle}>
              <h2>Volunteer With Us</h2>
            </div>
            <div className={styles.volunteerImage}>
              {/* Using a regular img tag for now, consider Next.js Image component for optimization */}
              <img
                src="/images/volunteer-image.jpg"
                alt="Volunteers picking up trash"
                className={styles.volunteerImg}
              />
            </div>
            <div className={styles.volunteerDetails}>
              <p>
                We're always looking for passionate individuals to join our team of volunteers.
                Whether you can help for a few hours or make a regular commitment, your
                time and talents can make a real difference in our community.
              </p>
              <ul className={styles.volunteerOpportunities}>
                <li>Program Support</li>
                <li>Administrative Assistance</li>
                <li>Event Planning</li>
                <li>Fundraising</li>
                <li>Community Outreach</li>
              </ul>
              <p>
                Ready to join our programs? Apply now to get started on your journey with TimeLee CARES Foundation.
              </p>
              <div className={styles.volunteerButtons}>
                <a href="mailto:info@timeleecares.org" className="btn btn--primary" aria-label="Send email about volunteering" title="Contact us about volunteer opportunities">
                  Email for Volunteering
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
